var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-btns"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('download'),expression:"'download'",modifiers:{"bottom":true}}],staticClass:"btn download",on:{"click":_vm.saveImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }